import { Axios, setAuthToken } from "./config/Axios";

////// AUTHENTICATION //////
// Authenticate User
export const authenticateUser = async (params) => {
  const response = await Axios.post("/auth/authenticate", params);
  return response;
};

// Verify User
export const verifyAccount = async (params) => {
  setAuthToken();
  const response = await Axios.post("/auth/verifyAccount", params);
  return response;
};

// Login User
export const loginUser = async (params) => {
  setAuthToken();
  const response = await Axios.post("/auth/login", params);
  return response;
};

////// AUTHENTICATION //////

////// PRIVATE REQUESTS //////

export const getUserInfo = async () => {
  setAuthToken();
  const response = await Axios.get("/admin/user-info");
  return response;
};

export const fetchCategories = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/fetch-category", params);
  return response;
};

export const fetchSessions = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/fetch-sessions", params);
  return response;
};

export const resumeSession = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/resume-session", params);
  return response;
};

export const startChat = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/start-session", params);
  return response;
};

export const chatMessage = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/session-chat", params);
  return response;
};

export const endSession = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/end-session", params);
  return response;
};

// Transcribe audio
export const transcribeAudio = async (formData) => {
  setAuthToken();
  const response = await Axios.post("/user/transcribe-audio", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const getSessionSummary = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/session-summary", params);
  return response;
};

export const getSessionReview = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/get-reviews", params);
  return response;
};

export const handleReview = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/handle-review", params);
  return response;
};

export const deleteReview = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/delete-review", params);
  return response;
};

export const getStatisticsData = async (params) => {
  setAuthToken();
  const response = await Axios.get("/user/get-statistics", params);
  return response;
};

export const getUserDetails = async (params) => {
  setAuthToken();
  const response = await Axios.get("/user/user-details", params);
  return response;
};

export const updateUserDetails = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/update-user-details", params);
  return response;
};

export const updateUserLanguage = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/update-language", params);
  return response;
};

export const updateUserImage = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/update-image", params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const deleteProfileImage = async (params) => {
  setAuthToken();
  const response = await Axios.get("/user/delete-image", params);
  return response;
};

export const updateSessionDuration = async (params) => {
  setAuthToken();
  const response = await Axios.post("/user/update-session-duration", params);
  return response;
};

export const getTempTokenAzureSTT = async () => {
  setAuthToken();
  const response = await Axios.get("/user/get-azure-token");
  return response;
};

export const checkAccountStatus = async () => {
  setAuthToken();
  const response = await Axios.get("/user/check-account-status");
  return response;
};
